import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Búsqueda',
  },
  searchResults: {
    showMore: 'Mostrar más resultados',
    noResults: 'Lo sentimos, no hemos encontrado ningún resultado que se corresponda con lo buscado <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® o PEFC',
      ecofriendly: 'materiales ecológicos',
      overnight: 'envío Exprés y Overnight',
      sameday: 'sameday',
      express: 'express',
      onlineDesign: 'diseñar online',
    },
    taglines: {
      home: 'Más informatión',
      text: 'Más informatión',
      themes: 'Más informatión',
      external: 'Más informatión',
      info: 'Más informatión',
      category: 'Más informatión',
      content: 'Más informatión',
      product: 'Configurar ahora',
    },
    headings: {
      categories: 'Categorías de productos',
      products: 'Productos',
      external: 'Más información',
    },
    slider: {
      previousSlide: 'Ver contenido anterior',
      nextSlide: 'Ver contenido siguiente',
    },
  },
  searchInput: {
    inputTooShortError: 'Su término de búsqueda es demasiado corto (min 2)',
    results: 'Resultados',
    result: 'Resultado',
    youSearchFor: 'Se muestran resultados de',
    suggestedTerm: {
      didYouMean: 'Intendevi',
      resultsFor: 'Buscar, en cambio',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Vista de la lista',
      gridButtonTooltip: 'Vista de azulejos',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Borrar todos los filtros',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filtros',
        buttonsTooltipLabel: 'Ver',
        resultLabel: 'Resultados de la búsqueda',
      },
      contexts:
        {
          product: 'Productos',
          content: 'Diverso',
          all: 'all',
          category: 'Categorías de productos',
          external: 'Más información',
        },
    },
    breadcrumbs: {
      start: 'Inicio',
      search: 'Búsqueda',
    },
  },
  sideBar: {
    filter: 'Filtrar',
    filterOverwrite: {
      category: {
        text: 'Categorías',
      },
      rootCategory: {
        text: 'Categorías',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Online design',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Su sesión ha caducado y debe volver a conectarse. Se le remitirá al inicio de sesión inmediatamente',
      server403: 'La solicitud no se ha aplicado porque carece de credenciales de autenticación válidas. Por favor, vuelva a cargar la página o póngase en contacto con nuestro servicio de atención al cliente.',
      default: 'Se ha producido un error en el servidor. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente.',
    },
    errors: {
      server400: 'La solicitud estaba malformada. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
      server404: '404 Página no encontrada. Por favor, vaya a la página anterior o póngase en contacto con nuestro servicio de atención al cliente.',
      server500: 'Se ha producido un error en el servidor. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
      server501: 'Se ha producido un error en el servidor. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
      server502: 'Se ha producido un error en el servidor y recibe una respuesta no válida. Por favor, vuelva a cargar la página o póngase en contacto con nuestro servicio de atención al cliente',
      server503: 'Se ha producido un error en el servidor. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
      server504: 'Se ha producido un error en el servidor. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
      default: 'El servidor tiene un problema con la solicitud. Por favor, recargue la página o póngase en contacto con nuestro servicio de atención al cliente',
    },
  },
};
export default translation;
